import { makeVar } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { getOperationName } from '@apollo/client/utilities';

import {
  AiDisplayImageDocument,
  AiGeneratedImageDocument,
  AiOriginalImageAnonymousDocument,
  CreateAiOriginalImagePlaceholderDocument,
  CustomizeAiImageDocument,
  GenerateAiImageDocument,
  UpdateAiDisplayImageDocument,
  UploadAiOriginalImageDocument,
} from 'src/shared/graphql/generated';
import { isDefined } from 'src/shared/helpers/guards';

export const designerAnonymousSessionVar = makeVar('');

const includedQueries = [
  AiDisplayImageDocument,
  AiGeneratedImageDocument,
  AiOriginalImageAnonymousDocument,
  CreateAiOriginalImagePlaceholderDocument,
  CustomizeAiImageDocument,
  GenerateAiImageDocument,
  UpdateAiDisplayImageDocument,
  UploadAiOriginalImageDocument,
] as const;

const includedOperations = includedQueries
  .map(document => (document ? getOperationName(document) : undefined))
  .filter(isDefined);

const setDesignerAnonymousSessionLink = setContext(
  ({ operationName }, { headers }) => {
    const included = operationName
      ? includedOperations.includes(operationName)
      : false;

    const designerSessionToken = designerAnonymousSessionVar();
    if (!designerSessionToken || !included) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      return { headers };
    }

    return {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      headers: designerSessionToken
        ? {
            ...headers,
            'X-GML-ANONYMOUS-SESSION': designerSessionToken,
          }
        : headers,
    };
  },
);

export { setDesignerAnonymousSessionLink };
